import { useLang } from "@/context/LanguageContext";
import { PageHeader } from "@/components/Section";
import Reveal from "@/components/Reveal";

const Impressum = () => {
  const { t } = useLang();
  const im = t.impressum;
  return (
    <div data-testid="impressum-page">
      <PageHeader kicker={im.kicker} title={im.title} />
      <section className="pb-24 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal direction="up" className="bg-[#0F0F0F] border border-white/10 p-8 md:p-12">
          <p className="text-neutral-300 whitespace-pre-line leading-relaxed text-sm md:text-base">
            {im.content}
          </p>
        </Reveal>
      </section>
    </div>
  );
};

export default Impressum;
